import { useCallback, useEffect, useState } from "react";

import { useTelegramWebApp, useWebAppEvent } from "./useTelegramWebApp.js";
import type {
  TelegramColorScheme,
  TelegramThemeParams,
} from "../lib/telegram-types.js";

export interface ThemeState {
  params: TelegramThemeParams;
  scheme: TelegramColorScheme;
}

const DEFAULTS: ThemeState = {
  params: {},
  scheme: "light",
};

export function useThemeParams(): ThemeState {
  const wa = useTelegramWebApp();
  const read = useCallback((): ThemeState => {
    if (!wa) return DEFAULTS;
    return {
      params: wa.themeParams,
      scheme: wa.colorScheme,
    };
  }, [wa]);

  const [state, setState] = useState<ThemeState>(read);

  useEffect(() => {
    setState(read());
  }, [read]);

  useWebAppEvent("themeChanged", () => {
    setState(read());
  });

  return state;
}
